import { UserDetailFromJSON, UserDetailToJSON, } from './UserDetail';
/**
 * Check if a given object implements the UpdateAgreementInfoResponse interface.
 */
export function instanceOfUpdateAgreementInfoResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "user" in value;
    return isInstance;
}
export function UpdateAgreementInfoResponseFromJSON(json) {
    return UpdateAgreementInfoResponseFromJSONTyped(json, false);
}
export function UpdateAgreementInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'user': UserDetailFromJSON(json['user']),
    };
}
export function UpdateAgreementInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user': UserDetailToJSON(value.user),
    };
}
